import { Pipe, PipeTransform } from '@angular/core';
import { Conditions } from '@vsolv/packages/conditions/domain';
import { Property } from '@vsolv/packages/properties/domain';

@Pipe({ name: 'conditionProperty', standalone: false })
export class ConditionPropertyPipe implements PipeTransform {
  // `properties` is the fully resolved list (hardcoded + property-set + dimensions) —
  // see ConditionPreviewComponent, which is responsible for assembling it since dimension
  // lookup is async.
  transform(propertyId: string, properties: (Property.Model<Property.PropertyType> | Conditions.Property)[]) {
    return this.getPropertyFromId(propertyId, properties);
  }

  private getPropertyFromId(
    propertyId: string,
    properties: (Property.Model<Property.PropertyType> | Conditions.Property)[]
  ): Property.Model<Property.PropertyType> | Conditions.Property | undefined {
    for (const property of properties) {
      if (property.valueKey === propertyId) {
        return property;
      } else if (propertyId.startsWith(property.valueKey)) {
        return this.getPropertyFromId(
          propertyId.replace(property.valueKey + '.', ''),
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (property as Property.ObjectModel).properties?.map(assignment => assignment.property!) ?? []
        );
      }
    }
    return undefined;
  }
}
